<template>
    <div class="hide-overflow home" style="position: relative;">
        <!-- <side-nav></side-nav> -->
        <header-layout bgcolor="primary"/>
        <div v-show="!search" class="home-slider">
            <home-carousel></home-carousel>
            <!-- <home-buttons></home-buttons> -->
            <card-item title="ITEMS" titleColor="#0c0c0c" linkTitle="View all items on sale" route="/product-list">
                <items-on-sale></items-on-sale>
            </card-item>
            <card-item title="MOST POPULAR" titleColor="#0c0c0c" linkTitle="View all" route="/product-list">
                <most-popular-products></most-popular-products>
            </card-item>
            <!--<card-item title="TOP 10 BRANDS ON SALE" titleColor="#0c0c0c" linkTitle="View all" route="/brand-list">-->
                <!--<top-brand-sale></top-brand-sale>-->
            <!--</card-item>-->
            <!--<card-item title="ITEMS YOU MIGHT LIKE" titleColor="#0c0c0c" linkTitle="See more" route="/product-list">-->
                <!--<items-might-like></items-might-like>-->
            <!--</card-item>-->
        </div>
        <search-result v-show="search" :result="search" :category_id="category_id" :search_name="search_name"></search-result>
        <bottom-nav></bottom-nav>
    </div>
</template>

<script>
    import Swiper from "swiper";
    // import HeaderLayout from "../layouts/HeaderLayout";
    export default {
        components:
        {
            HeaderLayout: () => import("../layouts/HeaderLayout")
        },
        data() {
            return {
                text: '',
                bgCover: require('../assets/cover-photo.jpg'),
                search: null,
                category_id: null,
                search_name: null,
                offsetTop: 0,
                bgprimary: 'primary'
            }
        },
        methods:
        {
            onScroll (e) {
                this.offsetTop = e.target.scrollTop;
            },

            onSearch() {
                EventBus.$off('onSearch');
                EventBus.$on('onSearch', (res) =>
                {
                    this.search = res;
                });

                EventBus.$off('onSearchName');
                EventBus.$on('onSearchName', (res) =>
                {
                    this.search_name = res;
                });

                EventBus.$off('onSearchInit');
                EventBus.$on('onSearchInit', (res) =>
                {
                    this.init();
                });
            },
            putCategory() {
                if (this.$route.query.id) {
                    this.category_id = this.$route.query.id;
                }
            },
            putSearch() {
                if (this.$route.query.list) {
                    this.search = JSON.parse(this.$route.query.list);
                }
            },
            init() {
                this.putCategory();
                this.putSearch();
            },
            onShowDefault() {
                EventBus.$off('onShowDefault');
                EventBus.$on('onShowDefault', (res) =>
                {
                    this.search = null;

                    setTimeout(function () {
                        window.dispatchEvent(new Event('resize'));
                    }, 1);
                });
            }
        },
        mounted() {
            this.onSearch();
            this.onShowDefault();
            this.init();
            // console.log("%c　∧＿∧ \n" +
            //     "（｡･ω･｡)つ━☆・*。\n" +
            //     "⊂　　 ノ 　　　・゜+.\n" +
            //     " しーＪ　　　°。+ *´¨)\n"
            //     , 'color: #4285f4');
        }
    }

</script>

<style lang="scss">
</style>
